function guid() {
  const s = [];
  const hexDigits = "0123456789abcdef";
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.charAt(Math.floor(Math.random() * 16));
  }
  s[8] = s[13] = s[18] = s[23] = "-";
  return s.join("");
}

export { guid as default };
//# sourceMappingURL=guid.mjs.map
